export default __webpack_public_path__ + "static/media/LogoC1DefaultWithText.31db91e5.svg";